type Props = {
  size?: number;
  color?: string;
};

export function Wordmark({ size = 18, color = 'currentColor' }: Props) {
  return (
    <div className="jp-mark" style={{ fontSize: size, color, lineHeight: 0.92 }}>
      <div>
        jones<span className="plus">+</span>
      </div>
      <div>palmer</div>
    </div>
  );
}
